function r(o) {
  var e = typeof o;
  return e == "string" || e == "number" || e == "symbol" || e == "boolean" ? o !== "__proto__" : o === null;
}
var t = r;
export {
  t as default
};
//# sourceMappingURL=_isKeyable.js.map
